import { useRef } from "react";

const BM_PATHS = [
  "M10.29 7.38L0.49 14.06L0.33 24.46C0.23 30.17 0.20 35.01 0.26 35.16C0.33 35.35 0.78 34.83 1.24 34.04C1.70 33.26 2.58 31.92 3.17 31.02L4.25 29.38L4.25 23.08C4.25 16.97 4.28 16.78 5.00 16.29C13.49 10.29 20.31 6.00 20.83 6.30C21.13 6.49 24.26 8.58 27.76 10.96C31.25 13.35 34.35 15.29 34.64 15.29C35.17 15.29 37.22 12.94 37.22 12.38C37.22 12.12 21.09 1.01 20.41 0.82C20.21 0.78 15.64 3.73 10.29 7.38Z",
  "M44.96 3.54C41.76 4.62 39.05 5.63 38.92 5.78C38.79 5.93 39.48 6.82 40.46 7.79C41.44 8.76 42.16 9.73 42.09 9.96C41.70 11.11 25.21 31.69 23.80 32.81C21.78 34.38 18.48 34.83 16.72 33.78C15.35 32.96 14.56 33.04 13.06 34.01C11.43 35.09 11.46 35.16 13.13 36.54C16.29 39.19 20.80 39.49 24.62 37.33C27.17 35.91 28.08 34.94 33.47 27.93C40.10 19.35 45.16 13.05 45.36 13.05C45.49 13.05 46.43 13.91 47.44 14.95C49.18 16.70 49.31 16.78 49.44 15.96C49.60 14.99 51.30 4.10 51.53 2.50C51.69 1.19 51.95 1.16 44.96 3.54Z",
  "M16.95 13.98C13.32 15.29 10.29 18.98 9.34 23.12C8.82 25.54 8.98 25.69 10.94 24.65C11.76 24.20 12.54 23.86 12.70 23.86C12.87 23.86 13.39 23.12 13.85 22.26C16.26 17.53 21.42 16.48 24.85 20.02C26.29 21.51 27.10 23.04 27.10 24.24C27.10 25.36 27.46 25.17 29.00 23.08C30.69 20.88 30.60 20.14 28.28 17.38C25.44 14.06 20.64 12.64 16.95 13.98Z",
  "M22.79 22.97C22.69 23.08 20.87 23.71 18.74 24.42C7.84 27.89 2.84 32.66 0.82 41.39C-0.03 45.01 0.03 45.16 2.19 45.04L4.08 44.93L4.28 43.22C5.06 36.99 9.93 31.81 17.47 29.27C24.59 26.88 24.98 26.70 25.08 25.84C25.31 24.13 23.61 22.00 22.79 22.97Z",
  "M38.20 25.80L36.41 28.11L36.34 34.12C36.28 37.40 36.24 40.23 36.24 40.38C36.24 40.53 35.17 40.64 33.89 40.57L31.51 40.46L31.41 37.55L31.31 34.60L29.55 36.62C27.66 38.74 26.97 41.43 27.56 44.15L27.76 45.12L33.96 45.12L40.16 45.12L40.16 34.30C40.16 28.34 40.13 23.49 40.07 23.49C40.03 23.49 39.18 24.54 38.20 25.80Z",
  "M7.02 41.91C6.76 42.62 6.53 43.66 6.53 44.19L6.53 45.12L14.30 45.08C21.22 45.08 21.94 45.01 21.06 44.56C14.86 41.20 13.94 40.87 10.68 40.72L7.51 40.57L7.02 41.91Z",
];

let __bmId = 0;

interface BrandMarkProps {
  size?: number;
  className?: string;
}

export function BrandMark({ size = 24, className = "" }: BrandMarkProps) {
  const idRef = useRef<number | null>(null);
  if (idRef.current === null) idRef.current = ++__bmId;
  const gid = "bm-grad-" + idRef.current;

  return (
    <svg
      className={"brandmark " + className}
      width={size}
      height={size}
      viewBox="-2 -1 51 48"
      fill="none"
      aria-label="AdresFlow"
      role="img"
    >
      <defs>
        <linearGradient id={gid} x1="24" y1="2" x2="24" y2="44" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#f23ce0" />
          <stop offset="0.5" stopColor="#a945ee" />
          <stop offset="1" stopColor="#3f5ad9" />
        </linearGradient>
      </defs>
      <g fill={`url(#${gid})`}>
        {BM_PATHS.map((d, i) => (
          <path key={i} d={d} />
        ))}
      </g>
    </svg>
  );
}
